import { Pipe, PipeTransform } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Pipe({
    name: 'splitStringToArEn'
})
export class SplitStringToArEnPipe implements PipeTransform {

    constructor(public app: AppService) {}

    
    transform(sent: string): string {
        if (!sent || !sent.includes(' - ')) {
            return sent;
        }

        const parts = sent.split('-');
        const firstPart = parts[0];

        if (this.app?.languageCode === 'ar') {
            return this.isProbablyArabic(firstPart) ? parts[0] : parts[1];
        } else if (this.app?.languageCode === 'en') {
            return this.isProbablyArabic(firstPart) ? parts[1] : parts[0];
        }

        return sent; // Default case
    }

    isProbablyArabic(str: string): boolean {
        var Character
        for (var i = 0; i < str.length; i++) {
            let c = str.codePointAt(i);
            if (c >= 0x0600 && c <= 0x06E0)
                return true;
        }
        return false;
    }
}


// splitStringToArAndEn(sent: string): string {
//     if (!sent) { return }
//     if (isPlatformBrowser(this.platformId)) {
//       let x = sent?.split('-')
//       let y = x[0]
//       if (this?.app?.languageCode == 'ar') {
//         if (this.isProbablyArabic(y)) {
//           return x[0]
//         } else {
//           return x[1]
//         }
//       } else if (this?.app?.languageCode == 'en') {
//         if (this.isProbablyArabic(y)) {
//           return x[1]
//         } else {
//           return x[0]
//         }
//       }
//     } else {
//       return sent
//     }
//   }